import { Box, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import EditFillSVG from "../../../../../media/images/icons/editfill-icon";
import Boxoutline from "../../../../../media/images/icons/outline-box";
import LocationFill from "../../../../../media/images/icons/location-fill";
import { addCommas } from "@persian-tools/persian-tools";
import ArrowUpFillType3SVG from "../../../../../media/images/icons/arrow-up-typ3";
import CustomButton from "../../../../components/CustomButton";
import CloseCircleSVG from "../../../../../media/images/icons/close-icon";
import ModalLayout from "../../../../components/ModalLayout";
import { useFormik } from "formik";
import PriceInput from "./PriceInput";

interface Props {
  open: boolean;
  handleClose: () => void;
}
export default function EditTenderOfferModal({ handleClose, open }: Props) {
  const theme = useTheme();

  const [priceState, setPriceState] = useState("");

  const formik = useFormik({
    initialValues: {
      orderId: "",
      price: "",
    },
    onSubmit: (values) => {
      console.log(JSON.stringify(values, null, 2));
    },
  });

  const handleChangePrice = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target;

    if (value.startsWith("0") && value.length > 1 && value[1] !== ".") {
      value = value.slice(1);
    }

    const numericValue = value.replace(/[^\d]/g, ""); // Remove non-numeric characters
    const formattedValue = addCommas(numericValue); // Format the value with commas
    formik.setFieldValue("price", numericValue); // Update Formik's field value
    setPriceState(formattedValue);

    // formik.setFieldValue("price", addCommas(value));
  };

  return (
    <ModalLayout open={open} setOpen={handleClose}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            justifyContent: "center",
          }}
        >
          <EditFillSVG color={theme.palette.secondary.main} />
          <Typography
            color={"secondary.main"}
            sx={{
              fontSize: "18px",
              fontWeight: "700",
            }}
          >
            ویرایش سریع مناقصه
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              padding: "4px",
              borderRadius: "8px",
              //   border: "1px solid gray",
              borderColor: "info.main",
              borderStyle: "solid",
              borderWidth: "1px",
              gap: "4px",
            }}
          >
            <Box
              sx={{
                backgroundColor: "info.light",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "6px",
                borderRadius: "8px",
              }}
            >
              <Boxoutline color={theme.palette.textColor.main} />
            </Box>

            <Box
              sx={{
                flex: "1",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "12px",
                  }}
                >
                  کنستانتره سنگ آهن فلان
                </Typography>
                <Box
                  sx={{
                    // border: "1px solid gray",
                    display: "flex",
                    alignItems: "center",
                    paddingX: "4px",
                    paddingY: "4px",
                    borderRadius: "6px",
                    backgroundColor: "info.light",
                    gap: "4px",
                  }}
                >
                  <LocationFill size={18} color={theme.palette.info.dark} />
                  <Typography
                    noWrap
                    color="textColor.main"
                    sx={{
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    سیستان و بلوچستان
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    // backgroundColor: "primary.light",
                    padding: "4px",
                    borderRadius: "8px",
                    gap: "4px",
                  }}
                >
                  {/* <BigCarIcon2 color={theme.palette.primary.main} /> */}
                  <Typography
                    noWrap
                    color="textColor.main"
                    sx={{
                      fontSize: "12px",
                    }}
                  >
                    کرایه :{" "}
                  </Typography>
                  <Typography
                    color="success.main"
                    sx={{
                      fontSize: "14px",
                    }}
                  >
                    {addCommas(80000000)}
                  </Typography>
                  <Typography
                    color="success.main"
                    sx={{
                      fontSize: "10px",
                    }}
                  >
                    ریال
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    padding: "4px",
                    borderRadius: "6px",
                    gap: "4px",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: theme.palette.primary[50],
                      borderRadius: "5px",
                      paddingX: "4px",
                      paddingY: "4px",
                    }}
                  >
                    <Typography
                      noWrap
                      color="primary.main"
                      sx={{
                        fontSize: "12px",
                      }}
                    >
                      درحال برسی
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "info.light",
                      borderRadius: "5px",
                      paddingX: "4px",
                      paddingY: "4px",
                    }}
                  >
                    <Typography
                      noWrap
                      color="textColor.main"
                      sx={{
                        fontSize: "12px",
                      }}
                    >
                      12/05/1403
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              backgroundColor: theme.palette.secondary[50],
              borderRadius: "8px",
              display: "flex",
              paddingX: "8px",
              paddingY: "8px",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <ArrowUpFillType3SVG color={theme.palette.secondary.main} />
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
                color={theme.palette.secondary[600]}
              >
                آخرین کرایه پیشنهادی شما:
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Typography color={theme.palette.secondary[600]}>
                {addCommas(80000000)}
              </Typography>
              <Typography color="secondary.main">ریال</Typography>
            </Box>
          </Box>
          <Typography
            textAlign={"center"}
            sx={{
              fontSize: "14px",
              fontWeight: "700",
            }}
            color={"primary.main"}
          >
            کرایه پیشنهادی جدید خود را وارد کنید
          </Typography>
          <PriceInput
            handleChangeInput={handleChangePrice}
            name="price"
            value={priceState}
            error={formik.touched.price && Boolean(formik.errors.price)}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <CustomButton
              flex={1}
              // loading
              flexDirection="row-reverse"
              justifyContent="center"
              onClick={() => formik.handleSubmit()}
              title="ارسال پیشنهاد"
              bgColor="primary.main"
              textColor="#fff"
              fWeight="700"
              px="10px"
              py="12px"
              borderRadius="10px"
              icon1={<ArrowUpFillType3SVG size={22} color={"#fff"} />}
            />
            <CustomButton
              type="outlined"
              rippleColor={theme.palette.primary.main}
              // loading
              flexDirection="row-reverse"
              justifyContent="center"
              onClick={() => handleClose()}
              title="انصراف"
              fWeight="700"
              bgColor={theme.palette.primary[50]}
              textColor="primary.main"
              borderColor="primary.main"
              px="10px"
              py="12px"
              borderRadius="10px"
              icon1={
                <CloseCircleSVG size={22} color={theme.palette.primary.main} />
              }
            />
          </Box>
        </Box>
      </Box>
    </ModalLayout>
  );
}
